import { Dropdown } from '../overlay/Dropdown';
import { OverlayFilterPill, OverlayFilterPillProps } from './OverlayFilterPill';

export const DropDownFilterPill = (props: OverlayFilterPillProps) => (
  <OverlayFilterPill {...props} content={<Dropdown>{props.content}</Dropdown>}></OverlayFilterPill>
);
